import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {ScoresListHeaderModuleConfig} from "./scores-list-header-module.config";
import {ScoresListHeaderModuleState} from "./models/scores-list-header-module.state";

export class ScoresListHeaderModuleStore extends BaseMobxStore {
  static injectables = [ScoresListHeaderModuleConfig, ScoresListHeaderModuleState];
}

